import { HomeController } from "../../home/HomeController.js";
import { NoDisponibleController } from "../../home/NoDisponibleController.js";
import { OperacionController } from "../../operaciones/OperacionController.js";
import { OPERACIONES } from "../../operaciones/index.js";
import { tieneAcceso } from "../../operaciones/permisos.js";

// Router por hash: funciona en cualquier hosting estático sin configurar
// rewrites, que es lo que se buscaba para no tocar el server.
//
// Las rutas de las operaciones se generan desde el registro: agregar una
// operación no requiere tocar este archivo.

export class Router {
  constructor() {
    this.routes = {
      "": () => HomeController.render(),
      "no-disponible": () => NoDisponibleController.render(),
    };

    OPERACIONES.forEach((operacion) => {
      this.routes[operacion.clave] = () => {
        if (!tieneAcceso(operacion)) return NoDisponibleController.render();
        return OperacionController.render(operacion);
      };
    });
  }

  init() {
    window.addEventListener("hashchange", () => this.handleRoute());
    this.handleRoute();
  }

  handleRoute() {
    // Se aceptan tanto "#/descuento" como "#descuento".
    const hash = window.location.hash.slice(1).replace(/^\//, "");
    const [path] = hash.split("?");
    const route = this.routes[path] || this.routes[""];
    window.scrollTo(0, 0);
    route();
  }

  navigate(path) {
    window.location.hash = "/" + path;
  }
}
